export default __webpack_public_path__ + "static/media/exhibitions3.b54f05ac.png";